// System
import { useMemo } from 'react';
// Components
import { Stack } from '@mui/material';
import { RHFSelect, RHFTextField } from '@Components/hook-form';
import { MenuItemEx } from '@Components/shared/selects/MenuItemEx';
// Redux
import { localizationsListArray } from '../LocalizationsTitle/LocalizationsListArray';
// Styles
import Styles from './CreateLocalizationKeyContent.module.scss';

const useDropDown = () => {
  const languageDropdown = useMemo(
    () =>
      localizationsListArray?.map(({ language, annotation }) => (
        <MenuItemEx key={annotation} value={annotation} name="Languages">
          {language}
        </MenuItemEx>
      )),
    [localizationsListArray]
  );
  return {
    languages: languageDropdown,
  };
};

export const CreateLocalizationKeyContent = () => {
  const dropdown = useDropDown();

  return (
    <Stack className={Styles.CreateLocalizationKeyContent}>
      <RHFTextField name="localizationKey" label="Language Key" />
      <RHFTextField name="localizationValue" label="Language Value" />
      <RHFSelect label="language" name="language" variant="outlined">
        {dropdown.languages}
      </RHFSelect>
    </Stack>
  );
};
